import React, { useEffect } from "react";
import GenericRoutes from "./Routes";
import { AuthProvider } from "./lib/context/Auth/AuthContext";
import { NavbarProvider } from "./lib/context/NavBar/navbarContext";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { manageAppVersion } from "./lib/utils/versionManager";
function App() {
  const APP_VERSION = "1.0.26";

  // useEffect(() => {
  //   const manageAppVersion = () => {
  //     const versionCookie = document.cookie
  //       .split("; ")
  //       .find((cookie) => cookie.startsWith("app_version="));

  //     const currentVersion = versionCookie ? versionCookie.split("=")[1] : null;

  //     if (currentVersion === APP_VERSION) {
  //       if (!currentVersion) {
  //         document.cookie = `app_version=${APP_VERSION}; path=/; max-age=31536000`;
  //       }
  //       return false;
  //     }

  //     const cookiesToPreserve = [
  //       // Add cookies you want to keep during version updates
  //       'user_preferences',
  //       // 'theme_settings',
  //     ];

  //     const allCookies = document.cookie.split("; ");
  //     allCookies.forEach(cookie => {
  //       const [name] = cookie.split("=");
  //       if (name && !cookiesToPreserve.includes(name) && name !== 'app_version') {
  //         document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
  //         document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.${window.location.hostname};`;        
  //       }
  //     });

  //     document.cookie = `app_version=${APP_VERSION}; path=/; max-age=31536000; SameSite=Lax`;

  //     const localStorageToClear = [
  //       'old_cache',
  //       'deprecated_data'
  //     ];
  //     localStorageToClear.forEach(key => {
  //       localStorage.removeItem(key);
  //     });

  //     setTimeout(() => {
  //       window.location.reload();
  //     }, 150);

  //     return true;
  //   };

  //   manageAppVersion();
  // }, [APP_VERSION]);

   useEffect(() => {
    manageAppVersion(APP_VERSION, {     
      cookiesToPreserve: [
        "user_preferences",
        "auth_token",           
        "session",             
        "refresh_token",        
      ],
      localStorageToClear: [
        "old_cache", 
        "deprecated_data",    
      ],
      shouldReload: true  
    });
  }, [APP_VERSION]);


  return (
    <AuthProvider>
      <NavbarProvider>
        <GenericRoutes />
        <ToastContainer />
      </NavbarProvider>
    </AuthProvider>
  );
}

export default App;